import React, { useState } from 'react';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ManagableTable from 'app/shared/view-table/managable-table';
import { FileWrapper } from 'app/shared/model/shared.model';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  deleteMainProjectDocumentAttachmentQuery,
  fetchMainProjectDocumentAttachmentsQuery,
  updateMainProjectDocumentAttachmentStatusQuery,
} from 'app/edozvola/cases/case-main-project-documents/service/case-main-project-documents.queries';
import { previewMainProjectDocumentAttachment } from 'app/edozvola/cases/case-main-project-documents/service/case-main-project-documents.service';
import { MainProjectDocumentAttachmentView } from 'app/edozvola/cases/case-main-project-documents/model/case-main-project-documents.model';
import { getCaseContext } from 'app/shared/util/context-util';
import SignerListModal from 'app/shared/digital-signature/signer-list-modal';
import { ENTITY_TYPE } from 'app/shared/digital-signature/digital-signature.model';
import '../../../../shared/view-table/view-table.scss';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";

const MainProjectDocumentAttachmentsTable = ({ idMainProjectDocument }) => {
  const [idMainProjectDocumentAttachmentToDelete, setIdMainProjectDocumentAttachmentToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();
  const [signerListOpen, setSignerListOpen] = useState(false);
  const [idMainProjectDocumentAttachmentSigners, setIdMainProjectDocumentAttachmentSigners] = useState<number>(null);
  const [previewAttachmentPendingAttachmentId, setPreviewAttachmentPendingAttachmentId] = useState<number>(null);

  const { mutate: deleteMutation, isPending: isDeleting } = deleteMainProjectDocumentAttachmentQuery();
  const { mutate: changeStatusMutation, isPending: isChangingStatus } = updateMainProjectDocumentAttachmentStatusQuery();

  const openDeleteDialog = idToDelete => {
    setIdMainProjectDocumentAttachmentToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const openFileInNewTable = idMainProjectDocumentAttachment => {
    setPreviewAttachmentPendingAttachmentId(idMainProjectDocumentAttachment);
    previewMainProjectDocumentAttachment(idMainProjectDocumentAttachment).then((document: FileWrapper) => {
      if (document) {
        openFileInNewWindow(document.url);
      }
    })
      .finally(() => setPreviewAttachmentPendingAttachmentId(null));
  };

  const openSignerListModal = (value: number) => {
    setIdMainProjectDocumentAttachmentSigners(value);
    setSignerListOpen(true);
  };

  const renderTableRow = (value: MainProjectDocumentAttachmentView, mainProjectDocumentAttachmentIndex: number, setFieldValue) => {
    return (
      <tr key={mainProjectDocumentAttachmentIndex}>
        <td>
          <span>{value.name}</span>
        </td>
        <td>
          <span>{convertDateFromServer(value.createdDate)}</span>
        </td>
        <td>{value.lastSignerInstitution}</td>
        <td>
          <span>{value.lastValidSignature}</span>
        </td>
        <td>{value.status ? 'Aktivan' : 'Neaktivan'}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canViewDocument && (
              <TooltipWrapper message={'Pregledaj dokument'}>
                {previewAttachmentPendingAttachmentId === value.idMainProjectDocumentAttachment ?
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    className={'icon-table'}
                    spin={true}
                  /> :
                  <FontAwesomeIcon
                    icon={'file'}
                    className={'icon-table'}
                    aria-disabled={previewAttachmentPendingAttachmentId != null}
                    onClick={previewAttachmentPendingAttachmentId ? () => {} : () => openFileInNewTable(value.idMainProjectDocumentAttachment)}
                  />
                }
              </TooltipWrapper>
            )}

            {sidebarItemPair?.canViewSignatures && value.lastValidSignature !== null && value.lastValidSignature !== '' && (
              <TooltipWrapper message={'Pregledaj potpise'}>
                <FontAwesomeIcon
                  icon={'file-alt'}
                  className={'icon-table'}
                  aria-disabled={previewAttachmentPendingAttachmentId != null}
                  onClick={previewAttachmentPendingAttachmentId ? () => {} : e => openSignerListModal(value.idMainProjectDocumentAttachment)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && value.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon
                  icon={'trash-alt'}
                  className={'icon-table'}
                  aria-disabled={previewAttachmentPendingAttachmentId != null}
                  onClick={previewAttachmentPendingAttachmentId ? () => {} : () => openDeleteDialog(value.idMainProjectDocumentAttachment)}
                />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  const deleteAttachment = () => {
    deleteMutation(idMainProjectDocumentAttachmentToDelete);
    setDeleteModalShown(false);
  };

  return (
    <>
      <ManagableTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema priloga'}
        initialPaginationColumn={'name'}
        fetchDataQuery={fetchMainProjectDocumentAttachmentsQuery}
        fetchDataProps={[idMainProjectDocument]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Naziv priloga']} width={'200px'} />
        <ViewTableHeaderColumn renderSort sortKey={'createdDate'} columnLabels={['Datum unosa']} width={'100px'} />
        <ViewTableHeaderColumn
          renderSort
          sortKey={'lastValidSignature'}
          columnLabels={['Institucija zadnjeg potpisnika']}
          width={'150px'}
        />
        <ViewTableHeaderColumn renderSort sortKey={'lastSignerInstitution'} columnLabels={['Zadnji validni potpis']} width={'150px'} />
        <ViewTableHeaderColumn renderSort sortKey={'status'} columnLabels={['Status']} width={'90px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={sidebarItemPair?.readOnly ? '50px' : '100px'} />
      </ManagableTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje priloga</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={deleteAttachment} color={'danger'} />
        </ModalFooter>
      </Modal>
      {signerListOpen && (
        <SignerListModal
          entity={ENTITY_TYPE.MAIN_PROJECT_DOCUMENT_ATTACHMENT}
          idEntity={idMainProjectDocumentAttachmentSigners}
          onClose={() => setSignerListOpen(false)}
        />
      )}
    </>
  );
};

export default MainProjectDocumentAttachmentsTable;
